import {FATCA_CRS_CONSENT_KEYS, FatcaCrsCondition} from '@sollapay/enums';

import type {FatcaCrsDeclarationDTO, SignMainFatcaCrsPayload} from '@sollapay/types';

export interface FatcaCrsFormValues {
  conditions: FatcaCrsCondition[];
  consentDisclosure: boolean;
  consentAccuracyUpdate: boolean;
  consentSignature: boolean;
}

export const EMPTY_FATCA_CRS_FORM_VALUES: FatcaCrsFormValues = {
  conditions: [],
  consentDisclosure: false,
  consentAccuracyUpdate: false,
  consentSignature: false
};

export const toFatcaCrsFormValues = (
  declaration: FatcaCrsDeclarationDTO | null | undefined
): FatcaCrsFormValues => {
  if (!declaration) {
    return EMPTY_FATCA_CRS_FORM_VALUES;
  }
  const dv = declaration.declarationValues;
  return {
    conditions: Object.values(FatcaCrsCondition).filter(c => dv[c] === true),
    consentDisclosure: dv[FATCA_CRS_CONSENT_KEYS.DISCLOSURE] === true,
    consentAccuracyUpdate: dv[FATCA_CRS_CONSENT_KEYS.ACCURACY_UPDATE] === true,
    consentSignature: dv[FATCA_CRS_CONSENT_KEYS.SIGNATURE] === true
  };
};

export const toSignMainFatcaCrsPayload = (values: FatcaCrsFormValues): SignMainFatcaCrsPayload => {
  const declarationValues: Record<string, boolean> = {};
  for (const condition of Object.values(FatcaCrsCondition)) {
    declarationValues[condition] = values.conditions.includes(condition);
  }
  declarationValues[FATCA_CRS_CONSENT_KEYS.DISCLOSURE] = values.consentDisclosure;
  declarationValues[FATCA_CRS_CONSENT_KEYS.ACCURACY_UPDATE] = values.consentAccuracyUpdate;
  declarationValues[FATCA_CRS_CONSENT_KEYS.SIGNATURE] = values.consentSignature;
  return {declarationValues};
};
